module.exports = __webpack_public_path__ + "static/media/29EUNOG10.c569704a.jpg";